import { logError } from "@/services/logger";

// ─────────────────────────────────────────────
// errorHandlers.ts
// NOTE: window.onerror and unhandledrejection are intentionally
// NOT registered here. They are registered in app.ts using
// addEventListener so that logError() (with guards) handles them.
//
// This file is kept for any future non-Vue, non-axios error
// boundaries that need registering before the app boots,
// such as resource load errors (images, scripts, stylesheets).
// ─────────────────────────────────────────────

// Resource load error tracking (images, scripts, link tags)
// Uses capture phase (true) since load errors don't bubble
window.addEventListener(
    "error",
    (event: ErrorEvent | Event) => {
        const target = event.target as HTMLElement | null;

        // Only handle resource errors (img, script, link) — not JS errors
        // JS errors have event.error set; resource errors do not
        if (!target || !(event instanceof ErrorEvent === false) || (event as ErrorEvent).error) {
            return;
        }

        const tag = target.tagName?.toLowerCase();
        if (!["img", "script", "link"].includes(tag)) return;

        logError({
            type: "resource_error",
            message: `Failed to load ${tag}: ${(target as any).src || (target as any).href}`,
            url: (target as any).src || (target as any).href,
            context: {
                tag,
                page: window.location.pathname,
                query: window.location.search,
            },
        });
    },
    true // capture phase required for resource errors
);